import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Icon, IconWrapper, Link, Optional, useThemeContext } from '@honda-canada/design-system-react';
import { setDealerBannerHeight } from '../../core/reducers/ui';
import DealerHours from './DealerHours';
import RoutableSitecoreLink from '../RoutableSitecoreLink';
import themeStyles from './styles/SelectedDealerBanner.styles';
import { useAppName } from '../../utils/sitecoreContext';
const Container = themeStyles.apply(Box, 'Container');
const DealerStatusContainer = themeStyles.apply(Box, 'DealerStatusContainer');
const DealerNameLink = themeStyles.apply(Link, 'DealerNameLink');
const DealerHoursContainer = themeStyles.apply(DealerHours, 'DealerHoursContainer');
const SelectedDealerBannerUI = ({ bannerBackgroundColor, dealerName, dealerHours, dealerIcon, dealerLocatorUrl, testId = 'cy-selected-dealer-banner', }) => {
    // convert color string to hex value
    const themeColor = useThemeContext('colors', bannerBackgroundColor);
    const dispatch = useDispatch();
    const appName = useAppName();
    const [isExpanded, setIsExpanded] = useState(false);
    const dealerBannerRef = useRef(null);
    const handleClick = () => setIsExpanded(prev => !prev);
    const dealerLocatorCta = {
        href: dealerLocatorUrl,
        linktype: 'internal',
        text: dealerName,
    };
    useEffect(() => {
        if (dealerBannerRef.current) {
            dispatch(setDealerBannerHeight(dealerBannerRef.current.offsetHeight));
        }
    }, [dispatch, isExpanded]);
    return (_jsxs(Container, { bg: themeColor, "data-testid": testId, ref: dealerBannerRef, children: [_jsxs(Box, { display: "flex", children: [_jsx(IconWrapper, { "data-testid": "cy-dealer-hour-icon", size: "iconWrapper.sm", children: _jsx(Icon, { name: dealerIcon, color: "white", circleColor: "red", logoColor: themeColor }) }), _jsxs(DealerStatusContainer, { children: [_jsx(Box, { children: _jsx(DealerNameLink, { styling: "white", disableHover: true, variant: appName, as: RoutableSitecoreLink, field: dealerLocatorCta, "data-testid": `${testId}-dealer-name` }) }), _jsx(Optional, { when: isExpanded, children: _jsx(DealerHoursContainer, { ...dealerHours, "data-testid": `${testId}-dealer-hours`, variant: appName }) })] })] }), _jsx(IconWrapper, { size: "iconWrapper.sm", tabIndex: "0", cursor: "pointer", onClick: handleClick, "data-testid": `${testId}-${isExpanded ? 'up' : 'down'}-icon-button`, children: _jsx(Icon, { name: "animatedArrowUpDown", color: "white", toggle: isExpanded }) })] }));
};
export default SelectedDealerBannerUI;
